import React, { useContext } from 'react';
import { Link, NavLink } from 'react-router-dom';
import AuthContext from '../context/AuthContext';
import ThemeContext from '../context/ThemeContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faUser, 
  faSignOutAlt, 
  faFileAlt, 
  faComments, 
  faUsersCog, 
  faRobot,
  faRss,
  faSun,
  faMoon
} from '@fortawesome/free-solid-svg-icons';

const Navbar = () => {
  const { isAuthenticated, user, logout } = useContext(AuthContext);
  const { theme, toggleTheme } = useContext(ThemeContext);

  const authLinks = (
    <>
      <li className="nav-item">
        <NavLink className="nav-link" to="/templates">
          <FontAwesomeIcon icon={faFileAlt} className="me-1" /> Шаблоны
        </NavLink>
      </li>
      <li className="nav-item">
        <NavLink className="nav-link" to="/chat">
          <FontAwesomeIcon icon={faComments} className="me-1" /> Чат
        </NavLink>
      </li>
      <li className="nav-item">
        <NavLink className="nav-link" to="/rss">
          <FontAwesomeIcon icon={faRss} className="me-1" /> RSS
        </NavLink>
      </li>
      {user && user.role === 'director' && (
        <li className="nav-item">
          <NavLink className="nav-link" to="/users">
            <FontAwesomeIcon icon={faUsersCog} className="me-1" /> Управление пользователями
          </NavLink>
        </li>
      )}
      {user && user.role === 'director' && (
        <li className="nav-item">
          <NavLink className="nav-link" to="/models">
            <FontAwesomeIcon icon={faRobot} className="me-1" /> Модели API
          </NavLink>
        </li>
      )}
    </>
  );

  const guestLinks = (
    <>
      <li className="nav-item">
        <NavLink className="nav-link" to="/login">Вход</NavLink>
      </li>
    </>
  );

  return (
    <nav className={`navbar navbar-expand-lg navbar-dark bg-dark`}>
      <div className="container">
        <Link className="navbar-brand" to="/">AI Prompt Manager</Link>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav me-auto">
            {isAuthenticated ? authLinks : guestLinks}
          </ul>
          <ul className="navbar-nav">
            <li className="nav-item">
              <button 
                className={`btn nav-link theme-toggle-btn ${theme === 'dark' ? 'bg-light text-dark rounded-circle' : ''}`}
                onClick={toggleTheme}
                title={theme === 'light' ? 'Включить темную тему' : 'Включить светлую тему'}
              >
                <FontAwesomeIcon 
                  icon={theme === 'light' ? faMoon : faSun} 
                  className={theme === 'light' ? 'text-primary' : 'text-warning'}
                  size="lg"
                />
              </button>
            </li>
            {isAuthenticated && (
              <>
                <li className="nav-item dropdown">
                  <a
                    className="nav-link dropdown-toggle"
                    href="#"
                    id="navbarDropdown"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <FontAwesomeIcon icon={faUser} className="me-1" /> 
                    {user?.name} 
                    {user?.role === 'director' && <span className="badge bg-primary ms-1">Директор</span>}
                  </a>
                  <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="navbarDropdown">
                    <li>
                      <button className="dropdown-item" onClick={logout}>
                        <FontAwesomeIcon icon={faSignOutAlt} className="me-1" /> Выйти
                      </button>
                    </li>
                  </ul>
                </li>
                <li className="nav-item">
                  <button className="btn btn-outline-light btn-sm ms-2 mt-1" onClick={logout} title="Выйти из системы">
                    <FontAwesomeIcon icon={faSignOutAlt} />
                  </button>
                </li>
              </>
            )}
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar; 
